<template>
    <div>
        <template v-if="topup_payment_report === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Topup Payment Report </h1>
            </div>
            <div class="peopple-managment-main">
                <div class="people-management-inner-content pt-5 pb-0 pl-5 pr-5">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="label block-label"> Batch ID </label>
                                <input name="topupId" id="topupId" class="form-control" v-model="topupId" placeholder="Enter Batch ID">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="label block-label"> Mobile Number </label>
                                <input name="mobile_number" id="mobile_number" class="form-control" v-model="mobile_number" placeholder="Enter mobile number">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="label block-label"> Network </label>
                                <select v-model="network" id="network" name="network" class="selectpicker custom-select2">
                                    <option value="" selected>Select Network</option>
                                    <option value="jazz">Jazz</option>
                                    <option value="warid">Warid</option>
                                    <option value="zong">Zong</option>
                                    <option value="ufone">UFone</option>
                                    <option value="telenor">Telenor</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="label block-label"> From Date </label>
                                <datepicker name="from_date" v-model="from_date" id="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="label block-label"> To Date </label>
                                <datepicker name="to_date" v-model="to_date" id="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group align-right">
                                <br>
                                <button @click="getTopupBatchReport" v-if="!showBtn" class="btn btn-primary">Search</button>
                                <button @click="filterTable" v-if="showBtn" class="btn btn-primary">Search</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
                <div v-show="!hasPer" class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                    <div class="empty-main pt-0" style="height: 100px">
                        <div class="empty-inner">
                            <img src="/images/new_empty_payments.png" alt="" />
                            <h2> Hi, {{user}}! </h2>
                            <p> Select your requirements and export your desired report </p>
                        </div>
                    </div>
                </div>
                <div v-show="hasPer">
                    <div class="mt-3 mb-3 tbl-fiters-search-area  hidden-xs" v-if="export_topup_payment_report === true">
                        <div class="field-box export-attendance">
                            <button class="btn btn-primary export" @click="exportReport">Export Report</button>
                        </div>
                    </div>

                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <table id="topupPaymentReportTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th style="display: none">ID</th>
                                    <th>Batch ID</th>
                                    <th>Mobile Number</th>
                                    <th>Network</th>
                                    <th>Amount</th>
                                    <th>Transaction ID</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="topup_payment_report === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="topup_payment_report === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
	var dtTable = null;
    export default {
        data() {
            return {
				mobile_number : '',
				network : '',
				from_date : new Date(),
				to_date : new Date(),
				hasPer: false,
				user: '',
				showBtn: false,
				topup_payment_report: null,
				export_topup_payment_report: null,
				topupId: null,
            };
        },
        mounted() {
			this.$Progress.start();
			this.can('topup_payment_report|export_topup_payment_report').then(result => {
                this.topup_payment_report = result.topup_payment_report;
                this.export_topup_payment_report = result.export_topup_payment_report;
                this.user = result.user_name;
            }).then(result => {
                if(this.topup_payment_report == true){
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.finish();
                }
            });
        },
        methods: {
			exportReport: function(){
				this.$Progress.start();
				var formData = {
					'to_date': moment(this.to_date).format('YYYY-MM-DD'),
					'from_date': moment(this.from_date).format('YYYY-MM-DD'),
					'network': this.network,
					'mobile_number': this.mobile_number,
					'topupId': this.topupId,
                }
                axios.post('/api/topup_batch_payment_export', formData,{
					responseType: 'blob'
				})
				.then(res => {
					if(res.status == 200){
						const url = URL.createObjectURL(new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					}))

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'topupPaymentReport.xlsx')
					document.body.appendChild(link)
					link.click()
					this.$Progress.finish();
					}else{
						this.$Progress.fail();
						this.showAlertBox('error','Error to load data');
					}
				})
				.catch(err => {
					this.$Progress.fail();
					this.showAlertBox('error','Error to load data');
				});
			},
			filterTable(){
                dtTable.draw();
            },
            getTopupBatchReport: function(){
	            this.$Progress.start();
				var that = this;
				dtTable = $('#topupPaymentReportTable').DataTable({
					sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
					processing: true,
					serverSide: true,
					ajax: {
						"url": "api/topup_batch_payment_report",
						"data": function (d) {
							d.topupId = that.topupId;
							d.mobile_number = that.mobile_number;
							d.network = that.network;
							d.from_date = moment(that.from_date).format('YYYY-MM-DD');
							d.to_date = moment(that.to_date).format('YYYY-MM-DD');
						},
						"headers": window.axios.defaults.headers.common,
						"dataSrc": "records",
					},
					deferRender: true,
					columns: [
						{data: 'id', visible: false},
						{render: function(data,type,full){
							if(full.topupId != null){
								return full.topupId;
							}else{
								return "---";
							}
						}},
                        {render: function(data,type,full){
							if(full.mobileNo != null){
								return full.mobileNo;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.network != null){
								return full.network;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.amount != null){
								var amount = new Intl.NumberFormat().format(full.amount);
								return amount;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							if(full.transactionCode != null){
								return full.transactionCode;
							}else{
								return "---";
							}
						}},
						{render: function(data,type,full){
							var date = full['created_at'];
							return ''+moment(date).format('MMM D, Y')+'';
						}},
					],
					"order": [[ 0, "desc" ]],
					"initComplete": () => {
						that.hasPer = true;
						that.showBtn = true;
						this.$Progress.finish();
					}
				});
            },
        },
        created() {
			//
        }
    }
</script>
